import React from "react";
import { LockKeyhole, Store, CalendarClock, Radio } from "lucide-react";
import { useTheme } from "./ThemeProvider";

const formatDate = (value) => {
  if (!value) return "Not set";
  const [year, month, day] = String(value).slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return "Not set";
  return new Date(year, month - 1, day).toLocaleDateString("en-PH", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export default function SubscriptionPausedModal({ open, customer }) {
  const { currentTheme } = useTheme();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/50 px-4 py-6 backdrop-blur-md">
      <div className="w-full max-w-xl overflow-hidden rounded-[30px] border border-white/40 bg-white shadow-[0_30px_90px_rgba(15,23,42,0.32)]">
        <div
          className="relative border-b border-slate-100 px-6 py-6 sm:px-8"
          style={{
            background: `linear-gradient(135deg, ${currentTheme.color}12 0%, #ffffff 56%, #f8fafc 100%)`,
          }}
        >
          <div className="flex items-start gap-4">
            <div
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-white shadow-[0_16px_30px_rgba(15,23,42,0.18)]"
              style={{ background: currentTheme.color }}
            >
              <LockKeyhole className="h-7 w-7" />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.22em]" style={{ color: currentTheme.color }}>
                Access paused
              </p>
              <h2 className="mt-2 text-2xl font-bold tracking-tight text-slate-950">
                Subscription Renewal Required
              </h2>
              <p className="mt-2 text-sm leading-6 text-slate-500">
                This POS workspace is temporarily locked. Please contact your store admin or manager to renew the subscription.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-4 px-6 py-5 sm:px-8">
          <div className="grid gap-3 sm:grid-cols-2">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">
                <Store className="h-4 w-4" />
                Customer
              </div>
              <p className="mt-2 text-base font-semibold text-slate-950">
                {customer?.name || "Customer account"}
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">
                <CalendarClock className="h-4 w-4" />
                Billing period
              </div>
              <p className="mt-2 text-base font-semibold text-slate-950">
                {formatDate(customer?.subscription_start_date)} - {formatDate(customer?.subscription_end_date)}
              </p>
            </div>
          </div>

          <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
            <div className="flex items-start gap-3">
              <Radio className="mt-0.5 h-5 w-5 shrink-0" />
              <p>
                This notice updates in real time. Once the admin renews the subscription, access will resume automatically.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
